import { useApi } from "@services/useApi";
import { PricingTier } from "@store/generalTypes";
import { useEffect, useMemo, useState } from "react";
import { PricingHeader } from "../components/purchase-pricing/PricingHeader";
import { PricingTable } from "../components/purchase-pricing/PricingTable";
import "react-loading-skeleton/dist/skeleton.css";
import { last } from "lodash";
import { PricingInfo } from "../components/purchase-pricing/PricingInfo";
import Skeleton from "react-loading-skeleton";
import PricingSummary from "../components/purchase-pricing/PricingSummary";

const DEFAULT_ASSESSMENT_QUANTITY = 65;
const DEFAULT_MIN_QUANTITY_ASSESSMENTS_PURCHASE = 10;
const DEFAULT_MAX_QUANTITY_ASSESSMENTS_PURCHASE = 500;

export const PurchasePricing = (): JSX.Element => {
    const [pricingTiers, setPricingTiers] = useState(Array<PricingTier>());
    const minimumAssessmentQuantity = useMemo(
        () => pricingTiers[0]?.minimumQuantity ?? DEFAULT_MIN_QUANTITY_ASSESSMENTS_PURCHASE,
        [pricingTiers]
    );
    const maximumAssessmentQuantity = useMemo(
        () => last(pricingTiers)?.maximumQuantity ?? DEFAULT_MAX_QUANTITY_ASSESSMENTS_PURCHASE,
        [pricingTiers]
    );

    const { getAssessmentsPricings, loading } = useApi();

    const handleGetPrices = async (): Promise<void> => {
        const currentPrices = await getAssessmentsPricings();
        setPricingTiers(currentPrices);
    };

    useEffect(() => {
        void handleGetPrices();
    }, []);

    return (
        <div className="hero container pt-6">
            <PricingHeader />
            <div className="divider" />
            <PricingInfo maximumQuantity={maximumAssessmentQuantity} />
            <PricingTable loading={loading} pricingTiers={pricingTiers} />
            {loading ? (
                <Skeleton />
            ) : (
                <PricingSummary
                    pricingTiers={pricingTiers}
                    defaultAssessmentQuantity={DEFAULT_ASSESSMENT_QUANTITY}
                    minimumQuantity={minimumAssessmentQuantity}
                    maximumQuantity={maximumAssessmentQuantity}
                />
            )}
        </div>
    );
};
